<script lang="ts">
    import { mdiFormatListGroupPlus, mdiArrowRightBottom, mdiTrashCan } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { tooltip } from "../../../../helper"
    import TextField from "../edit/fields/TextField.svelte"
    import NumberField from "../../../widgets/fields/NumberField.svelte"
    import { operationHashBeginning } from "../../../../store"
    import { _ } from "svelte-i18n"

    export let operationEmailed: boolean
    export let position: OperationPositionOut
    export let activePosition: number
    export let operation: OperationOut
    export let grid: boolean
    export let gridBreakPoint: number
    export let addNewPositionService: (position: OperationPositionOut) => void
    export let sharedView: boolean = false
    const removeAdditionalPositionService = (position: OperationPositionOut, service: AdditionalPositionService) => {
        if (!position.additionalItems) position.additionalItems = []

        if (position.additionalItems) {
            for (let i = 0; i < position.additionalItems.length; i++) {
                if (position.additionalItems[i].number === service.number) {
                    position.additionalItems.splice(i, 1)
                }
            }

            // Update position numbers
            for (let i = 0; i < position.additionalItems.length; i++) {
                position.additionalItems[i].number = i + 1
            }
        }

        // Force template update after change position quantity
        operation.positions = operation.positions
    }
    let outerWidth: number
    let rows: HTMLDivElement[] = []
</script>

<svelte:window bind:outerWidth />
<div style="width: 100%;"></div>
{#if position?.additionalItems?.length}
    <div
        class="table"
        class:gridview="{grid == undefined ? outerWidth <= gridBreakPoint : grid}"
        class:tableview="{grid == undefined ? outerWidth > gridBreakPoint : !grid}"
    >
        {#each position.additionalItems || [] as service, i (i)}
            {#key $operationHashBeginning}
                <div
                    bind:this="{rows[i]}"
                    class="additional-services tablerow trow"
                    class:deleted="{position.orderQuantity == 0}"
                    style="pointer-events: {position.orderQuantity == 0 ? 'none' : 'auto'}"
                    class:active="{position.number == activePosition}"
                >
                    <div class="col center middle w-80" style="flex-grow: 0;">
                        <Icon path="{mdiArrowRightBottom}" size="24px" />
                        <div class="hidden-on-table">
                            {$_("components.additionalServices.serviceToPosition")}
                            {service.number}
                        </div>
                    </div>
                    <div class="col middle">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            <NumberField value="{service.amount}" />
                        {:else}
                            <TextField
                                type="number"
                                decimal="{0}"
                                label="{$_('components.additionalServices.amount')}"
                                higherThanZero="{true}"
                                bind:value="{service.amount}"
                                cssClass="transparent"
                                disabled="{operationEmailed}"
                            />{/if}
                    </div>
                    <div class="col middle dominantxxl">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            {service.service}
                        {:else}
                            <TextField
                                label="{$_('components.additionalServices.service')}"
                                bind:value="{service.service}"
                                cssClass="transparent"
                                disabled="{operationEmailed}"
                            />{/if}
                    </div>

                    <div class="col middle dominantxxl">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            {service.description}
                        {:else}
                            <TextField
                                row="{rows[i]}"
                                label="{$_('components.additionalServices.description')}"
                                multipleLines="{true}"
                                bind:value="{service.description}"
                                cssClass="transparent"
                                disabled="{operationEmailed}"
                            />{/if}
                    </div>
                    <div class="col middle w-150 mw-180">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            <NumberField value="{service.netPrice}" />
                        {:else}
                            <div style="display: flex; gap: 10px; align-items: flex-end;">
                                <strong style="margin-bottom: 5px">
                                    {$_("components.additionalServices.salesPrice")}
                                </strong>
                                <TextField
                                    type="number"
                                    disabled="{operationEmailed}"
                                    label="{$_('components.additionalServices.price')}"
                                    bind:value="{service.netPrice}"
                                    cssClass="transparent"
                                    showEuroSymbol="{true}"
                                />
                            </div>
                        {/if}
                    </div>

                    <div class="col mw-100 w-100 pw-140 action_buttons" style="justify-content: flex-start;">
                        {#if !operation?.statusSummary?.emailed && !operation?.statusSummary?.orderConfimationEmailed}
                            <button
                                class="btn delete"
                                use:tooltip="{{
                                    content: $_('components.additionalServices.deleteService'),
                                }}"
                                on:click|stopPropagation="{() => removeAdditionalPositionService(position, service)}"
                            >
                                <Icon path="{mdiTrashCan}" size="24px" />
                            </button>
                        {/if}
                    </div>

                    {#if position.additionalItems.length - 1 == i && !operation?.statusSummary?.emailed && !operation?.statusSummary?.orderConfimationEmailed && !sharedView}
                        <button
                            class="btn btn-secondary btn-rounded add-position-service hidden-on-mobile"
                            use:tooltip="{{
                                content: $_('components.additionalServices.addService'),
                            }}"
                            on:click|stopPropagation="{() => {
                                addNewPositionService(position)
                            }}"
                        >
                            <Icon path="{mdiFormatListGroupPlus}" size="24px" />
                        </button>
                    {/if}
                </div>
            {/key}
        {/each}
    </div>
    <div class="margin-lg border-sep" id="{`sep${position.number}`}"></div>
{/if}
